import React from 'react';
import { useSelector } from 'react-redux';
import { ArrowForward } from '@yme/assets/icons';
import { Button, CONTAINED_VARIANT, SIZE_36, SIZE_44, TRAILING_ICON } from '@yme/atoms/button';
import { useWindowSize } from '@yme/common/hooks';
import { getRTL } from '@yme/selectors/common';
import { colorCoreWhite1000 } from '@yme/tokens/colors';
import { HeadingLevel3, RegularTextLevel5 } from '@yme/tokens/typography';
import { DigitalDataMutation, setDigitalData } from '@yme/utils/common';
import { navigationItemFromLink } from '../Menu/utils';
import { CardInnerStyled, CardStyled, LinkStyled, SaleLabelStyled } from './styled';
export function Card({ content: { title, subtitle, image, button, saleLabelEnabled }, label, isSmall, closeMenuHandler, }) {
    const isRightToLeft = useSelector(getRTL);
    const { isDesktopView } = useWindowSize();
    const onClickHandler = () => {
        return () => {
            closeMenuHandler?.();
            if (!button?.link) {
                return;
            }
            setDigitalData(DigitalDataMutation.NAVIGATION, {
                pageSection: 'main_menu',
                navigationGroup: '',
                navigationItem: navigationItemFromLink(button?.link),
            });
        };
    };
    return (React.createElement(CardStyled, { backgroundUrl: image.src, srcSet: image.srcSet, isSmall: isSmall, isRightToLeft: isRightToLeft },
        saleLabelEnabled && React.createElement(SaleLabelStyled, { isRightToLeft: isRightToLeft }, label),
        React.createElement(CardInnerStyled, null,
            React.createElement(RegularTextLevel5, { color: colorCoreWhite1000, isUppercase: true }, subtitle),
            React.createElement(HeadingLevel3, { color: colorCoreWhite1000 }, title),
            React.createElement(LinkStyled, { to: button?.link, onClick: onClickHandler() },
                React.createElement(Button, { label: button.text, as: "span", size: isDesktopView ? SIZE_36 : SIZE_44, buttonVariant: CONTAINED_VARIANT, hasIconButton: TRAILING_ICON, iconComponent: ArrowForward, iconRotate: isRightToLeft ? 180 : 0, isDarkMode: true })))));
}
